import gql from 'graphql-tag';

export const GET_PARTNER_LINKS = gql`
  query GetDealerLinks($accountId: ID!) {
    aftermarketDealerPartnerLink(accountId: $accountId) {
      partnerLinkId
      name
      logo
      partnerProfile {
        name
      }
    }
  }
`;
